import { render, staticRenderFns } from "./BatchSelector.vue?vue&type=template&id=186d0f3a&scoped=true"
import script from "./BatchSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BatchSelector.vue?vue&type=style&index=0&id=186d0f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d0f3a",
  null
  
)

export default component.exports